module.exports = __webpack_public_path__ + "static/img/slide1_w.4442f57.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/caroussel/slide1_w.jpeg
// module id = EXL9
// module chunks = 1